import {
  type FC,
  type PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import LoadingOverlay from 'react-loading-overlay-ts';
import { ReservationPackageContext } from '../../../modules/context/guestPackageContext';
import { UserPropertiesContext } from '../../../modules/context/userPropertiesContext';
import { useAuth, useRequest } from '../../../modules/hooks';
import type { GuestPackageResponse } from '../../../modules/interfaces';
import { endpoints } from '../../../modules/mappers/urls';

export const ReservationPackageProvider: FC<PropsWithChildren> = ({ children }) => {
  const [reservationPackages, setReservationPackages] = useState<GuestPackageResponse[]>(
    [],
  );
  const { credentialsInfo } = useAuth()!;
  const { selectedProperty } = useContext(UserPropertiesContext)!;

  const URL = `${endpoints.RESERVATION_PACKAGES}`;
  const [{ data, loading }, getReservationPackage] = useRequest<GuestPackageResponse[]>(
    URL,
    'get',
    {
      authToken: credentialsInfo?.token,
      propertyId: selectedProperty?.property.uuid,
    },
    { manual: true },
  );

  useEffect(() => {
    if (!credentialsInfo?.token || !selectedProperty?.property.uuid) return;

    getReservationPackage();
  }, [credentialsInfo?.token, selectedProperty?.property.uuid]);

  useEffect(() => {
    if (!data) return;

    setReservationPackages(data.result);
  }, [data]);

  const reservationPackageContext = useMemo(() => {
    return { reservationPackages, getReservationPackage, loading };
  }, [reservationPackages, getReservationPackage, loading]);

  return (
    <LoadingOverlay
      active={loading}
      text="Wait while we get things ready."
      className="loading-page-v"
    >
      <ReservationPackageContext.Provider value={reservationPackageContext}>
        {children}
      </ReservationPackageContext.Provider>
    </LoadingOverlay>
  );
};
